<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Parámetros COA
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5007, 5078]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label class="" for="tab1" [appCheckPermission]="[5007, 5078]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-list"></i>Lista de Parámetros
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5007, 5078]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(1)" 
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5007, 5078]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-clipboard-list"></i>Plantillas
			</label>
		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-parameters-products-list *ngIf="history==0"></app-parameters-products-list>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-parameters-products-templates *ngIf="history==1"></app-parameters-products-templates>
			</div>
		</div>
	</div>

</div>